import { SummarySectionContainer } from '../../containers/orders-drawer/sections/summary';
import { TagsSectionContainer } from '../../containers/orders-drawer/sections/tags';
import { CustomerSectionContainer } from '../../containers/orders-drawer/sections/customer';
import { NotesSectionContainer } from '../../containers/orders-drawer/sections/notes';
import { ItemsSectionContainer } from '../../containers/orders-drawer/sections/ordered-items';
import { ConfigureShipmentSectionContainer } from '../../containers/orders-drawer/sections/single-order-csw';
import { CustomsDeclarationContainer } from '../../components/customs-declarations/container';
import { CustomsSectionContainer } from '../../containers/orders-drawer/sections/customs';
import { OtherShippingOptionsContainer } from '../../containers/orders-drawer/sections/other-shipping-options';

import { PICKUP_INFORMATION } from '../../constants/csw-ids';
import { ConfigureShipmentSection } from '../../components/orders-drawer/sections/single-order-csw/configure-shipment-section';
import { CustomerSection } from '../../components/orders-drawer/sections/customer/customer-section';
import { CustomsSectionLoader as CustomsSection } from '../../components/orders-drawer/sections/customs/customs-section';
import { ItemsSection } from '../../components/orders-drawer/sections/grouped-order-items/items-section';
import { NotesSection } from '../../components/orders-drawer/sections/notes/notes-section';
import { OtherShippingOptionsSection } from '../../components/orders-drawer/sections/other-shipping-options/other-shipping-options-section';
import { PickupInformationSection } from '../../components/orders-drawer/sections/pickup-information/pickup-information-section';
import { SummarySection } from '../../components/orders-drawer/sections/summary/summary-section';
import { TagsSection } from '../../components/orders-drawer/sections/tags/tags-section';

const ConfigureShipment = ConfigureShipmentSectionContainer(ConfigureShipmentSection);
const Customer = CustomerSectionContainer(CustomerSection);
const Customs = CustomsSectionContainer(CustomsDeclarationContainer(CustomsSection));
const Items = ItemsSectionContainer(ItemsSection);
const Notes = NotesSectionContainer(NotesSection);
const OtherShippingOptions = OtherShippingOptionsContainer(OtherShippingOptionsSection);
const Summary = SummarySectionContainer(SummarySection);
const Tags = TagsSectionContainer(TagsSection);

//  this is what the collection saved in the user setting looks like for v2
//  ['Shipping', 'Recipient', 'Items', 'Summary', 'Notes', 'Tags', 'Customs']

export const singleFulfillmentPlanComponents = [
  {
    name: 'SingleOrderCSW',
    render: () => <ConfigureShipment />,
    v2Name: 'Shipping',
  },
  {
    name: 'OrderedItems',
    render: () => <Items />,
    v2Name: 'Items',
  },
  {
    name: 'Customer',
    render: () => <Customer />,
    v2Name: 'Recipient',
  },
  {
    name: 'Notes',
    render: () => <Notes />,
    v2Name: 'Notes',
  },
  {
    name: 'Summary',
    render: () => <Summary />,
    v2Name: 'Shipping',
  },
  {
    name: 'Tags',
    render: () => <Tags />,
    v2Name: 'Tags',
  },
  {
    name: 'Customs',
    render: () => <Customs />,
    v2Name: 'Customs',
  },
  {
    name: 'OtherShippingOptions',
    render: () => <OtherShippingOptions />,
    v2Name: 'Shipping',
  },
  {
    name: PICKUP_INFORMATION,
    render: () => <PickupInformationSection />,
    v2Name: 'Shipping',
  },
];
